import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";

import { Logger } from "@noli/core";
import { flagsStore, langStore, useOpQueue } from "@noli/business";

import { CONTAINER_ID } from "@/utils/constants";
import useFileDropper from "@/hooks/useFileDropper";
import { useSaveProjectEvery } from "@/modules/projects/hooks/useSaveProjectEvery";
import { localCacheManager } from "@/modules/projects/localManager";

function Monitors() {
  const [timestamps, setTimestamps] = useState(new Set<number>());
  const { isDelayed, delayedOps } = useOpQueue();
  const lang = langStore.tgt;

  useFileDropper(lang, CONTAINER_ID);

  useEffect(() => {
    if (!isDelayed) {
      if (timestamps.size > 0) {
        setTimestamps(new Set());
      }
    } else {
      const newTimestamps = delayedOps
        .map(({ timestamp }) => timestamp)
        .filter((timestamp) => !timestamps.has(timestamp));
      if (newTimestamps.length > 0) {
        Logger.warn("操作过于频繁");
        setTimestamps(new Set([...Array.from(timestamps), ...newTimestamps]));
      }
    }
  });

  useSaveProjectEvery(60);
  useEffect(() => {
    localCacheManager.setDataFromBoard();
  }, [flagsStore.latestOpTime]);

  return null;
}

export default observer(Monitors);
